<template>
	<div v-if="supported" class="tw-content-section tw-light-grey-bg-color p-3 col-12 mb-3" v-permission="{juniper: 'view_posts'}">
		<div class="d-flex align-items-center justify-content-between">
			<div class="me-3 overflow-hidden">
				<h3 class="tw-content-section-title mb-1">Homepage Popup</h3>
				<p class="mb-0 text-truncate">
					<span class="badge me-2" :class="popup.active ? 'bg-success' : 'bg-secondary'">{{ popup.active ? 'Active' : 'Inactive' }}</span>
					<span>{{ popup.title || 'No popup configured' }}</span>
				</p>
			</div>
			<button class="btn tw-submit-btn flex-shrink-0" @click="openModal" :disabled="!userHasPermission('create_posts')">Configure Popup</button>
		</div>
	</div>
	<PopupModal ref="PopupModal" @popupSaved="handleSaved" />
</template>

<script>
	import PopupModal from '@/components/modals/PopupModal';
	import cms6Mixin from '@/mixins/cms6Mixin';
	import { permission } from '@/directives/permission';

	let site = localStorage.getObject('site');

	export default {
		name: 'HomepagePopup',
		components: {
			PopupModal,
		},
		directives: {
			permission,
		},
		data: () => ({
			supported: false,
			popup: {},
		}),
		async mounted() {
			// Popup is a Juniper (cms6) theme feature only
			if (!site || site.type != 'cms6') {
				return;
			}
			try {
				let res = await this.getPopup();
				if (res && res.status === 200 && res.data) {
					this.supported = !!res.data.supported;
					this.popup = res.data.data || {};
				}
			} catch (err) {
				this.supported = false;
			}
		},
		methods: {
			openModal() {
				this.$refs.PopupModal.showModal(this.popup);
			},
			handleSaved(popup) {
				this.popup = popup;
			},
		},
		mixins: [cms6Mixin],
	}
</script>

<style scoped>
	.tw-submit-btn {
		border-radius: 21.5px;
	}
</style>
